import React from "react";
import { MenuItem, Select, Box } from "@mui/material";
import { useTheme } from "@emotion/react";

const provinces = {
  "آذربایجان شرقی": [
    "آذرشهر",
    "اسکو",
    "اهر",
    "بستان‌آباد",
    "بناب",
    "تبریز",
    "جلفا",
    "چاراویماق",
    "سراب",
    "شبستر",
    "مراغه",
  ],
  "آذربایجان غربی": [
    "ارومیه",
    "اشنویه",
    "بوکان",
    "پیرانشهر",
    "تکاب",
    "چالدران",
    "خوی",
    "سردشت",
    "سلماس",
    "شاهین‌دژ",
    "ماکو",
    "مهاباد",
    "میاندوآب",
    "نقده",
  ],
  اردبیل: [
    "اردبیل",
    "بیله‌سوار",
    "پارس‌آباد",
    "خلخال",
    "کوثر",
    "گِرمی",
    "مِشگین‌شهر",
    "نَمین",
    "نیر",
  ],
  اصفهان: [
    "آران و بیدگل",
    "اردستان",
    "اصفهان",
    "برخوار و میمه",
    "تیران و کرون",
    "چادگان",
    "خمینی‌شهر",
    "خوانسار",
    "سمیرم",
    "شهرضا",
    "سمیرم سفلی",
    "فریدن",
    "فریدون‌شهر",
    "فلاورجان",
    "کاشان",
    "گلپایگان",
    "لنجان",
    "مبارکه",
    "نائین",
    "نجف‌آباد",
    "نطنز",
  ],
  ایلام: [
    "آبدانان",
    "ایلام",
    "ایوان",
    "دره‌شهر",
    "دهلران",
    "شیروان و چرداول",
    "مهران",
  ],
  بوشهر: [
    "بوشهر",
    "تنگستان",
    "جم",
    "دشتستان",
    "دشتی",
    "دیر",
    "دیلم",
    "کنگان",
    "گناوه",
  ],
  تهران: [
    "اسلام‌شهر",
    "پاکدشت",
    "تهران",
    "دماوند",
    "رباط‌کریم",
    "ری",
    "ساوجبلاغ",
    "شمیرانات",
    "شهریار",
    "فیروزکوه",
    "ورامین",
  ],
  "چهارمحال و بختیاری": [
    "اردل",
    "بروجن",
    "شهرکرد",
    "فارسان",
    "کوهرنگ",
    "لردگان",
  ],
  "خراسان جنوبی": [
    "بیرجند",
    "درمیان",
    "سرایان",
    "سربیشه",
    "فردوس",
    "قائنات",
    "نهبندان",
  ],
  "خراسان رضوی": [
    "بردسکن",
    "تایباد",
    "تربت جام",
    "تربت حیدریه",
    "چناران",
    "خلیل‌آباد",
    "خواف",
    "درگز",
    "رشتخوار",
    "سبزوار",
    "سرخس",
    "فریمان",
    "قوچان",
    "کاشمر",
    "کلات",
    "گناباد",
    "مشهد",
    "مه ولات",
    "نیشابور",
  ],
  "خراسان شمالی": [
    "اسفراین",
    "بجنورد",
    "جاجرم",
    "شیروان",
    "فاروج",
    "مانه و سملقان",
  ],
  خوزستان: [
    "آبادان",
    "امیدیه",
    "اندیمشک",
    "اهواز",
    "ایذه",
    "باغ‌ملک",
    "بندر ماهشهر",
    "بهبهان",
    "خرمشهر",
    "دزفول",
    "دشت آزادگان",
    "رامشیر",
    "رامهرمز",
    "شادگان",
    "شوش",
    "شوشتر",
  ],
  زنجان: ["ابهر", "ایجرود", "خدابنده", "خرمدره", "زنجان", "طارم", "ماه‌نشان"],
  سمنان: ["دامغان", "سمنان", "شاهرود", "گرمسار", "مهدی‌شهر"],
  "سیستان و بلوچستان": [
    "ایرانشهر",
    "چابهار",
    "خاش",
    "دلگان",
    "زابل",
    "زاهدان",
    "زهک",
    "سراوان",
    "سرباز",
    "کنارک",
    "نیک‌شهر",
  ],
  فارس: [
    "آباده",
    "ارسنجان",
    "استهبان",
    "اقلید",
    "بوانات",
    "پاسارگاد",
    "جهرم",
    "خرم‌بید",
    "خنج",
    "داراب",
    "زرین‌دشت",
    "سپیدان",
    "شیراز",
    "فراشبند",
    "فسا",
    "فیروزآباد",
    "قیر و کارزین",
    "کازرون",
    "لارستان",
    "لامِرد",
    "مرودشت",
    "ممسنی",
    "مهر",
    "نی‌ریز",
  ],
  قزوین: ["آبیک", "البرز", "بوئین‌زهرا", "تاکستان", "قزوین"],
  قم: ["قم"],
  کردستان: [
    "بانه",
    "بیجار",
    "دیواندره",
    "سروآباد",
    "سقز",
    "سنندج",
    "قروه",
    "کامیاران",
    "مریوان",
  ],
  کرمان: [
    "بافت",
    "بردسیر",
    "بم",
    "جیرفت",
    "راور",
    "رفسنجان",
    "رودبار جنوب",
    "زرند",
    "سیرجان",
    "شهر بابک",
    "عنبرآباد",
    "قلعه گنج",
    "کرمان",
    "کوهبنان",
    "کهنوج",
    "منوجان",
  ],
  کرمانشاه: [
    "اسلام‌آباد غرب",
    "پاوه",
    "ثلاث باباجانی",
    "جوانرود",
    "دالاهو",
    "روانسر",
    "سرپل ذهاب",
    "سنقر",
    "صحنه",
    "قصر شیرین",
    "کرمانشاه",
    "کنگاور",
    "گیلان غرب",
    "هرسین",
  ],
  "کهگیلویه و بویراحمد": ["بویراحمد", "بهمئی", "دنا", "کهگیلویه", "گچساران"],
  گلستان: [
    "آزادشهر",
    "آق‌قلا",
    "بندر گز",
    "ترکمن",
    "رامیان",
    "علی‌آباد",
    "کردکوی",
    "کلاله",
    "گرگان",
    "گنبد کاووس",
    "مراوه‌تپه",
    "مینودشت",
  ],
  گیلان: [
    "آستارا",
    "آستانه اشرفیه",
    "اَملَش",
    "بندر انزلی",
    "رشت",
    "رضوانشهر",
    "رودبار",
    "رودسر",
    "سیاهکل",
    "شَفت",
    "صومعه‌سرا",
    "طوالش",
    "فومَن",
    "لاهیجان",
    "لنگرود",
    "ماسال",
  ],
  لرستان: [
    "ازنا",
    "الیگودرز",
    "بروجرد",
    "پل‌دختر",
    "خرم‌آباد",
    "دورود",
    "دلفان",
    "سلسله",
    "کوهدشت",
  ],
  مازندران: [
    "آمل",
    "بابل",
    "بابلسر",
    "بهشهر",
    "تنکابن",
    "جویبار",
    "چالوس",
    "رامسر",
    "ساری",
    "سوادکوه",
    "قائم‌شهر",
    "گلوگاه",
    "محمودآباد",
    "نکا",
    "نور",
    "نوشهر",
  ],
  مرکزی: [
    "آشتیان",
    "اراک",
    "تفرش",
    "خمین",
    "دلیجان",
    "زرندیه",
    "ساوه",
    "شازند",
    "کمیجان",
    "محلات",
  ],
  هرمزگان: [
    "ابوموسی",
    "بستک",
    "بندر عباس",
    "بندر لنگه",
    "جاسک",
    "حاجی‌آباد",
    "شهرستان خمیر",
    "رودان",
    "قشم",
    "گاوبندی",
    "میناب",
  ],
  همدان: [
    "اسدآباد",
    "بهار",
    "تویسرکان",
    "رزن",
    "کبودرآهنگ",
    "ملایر",
    "نهاوند",
    "همدان",
  ],
  یزد: [
    "ابرکوه",
    "اردکان",
    "بافق",
    "تفت",
    "خاتم",
    "صدوق",
    "طبس",
    "مهریز",
    "مِیبُد",
    "یزد",
  ],
  البرز: ["کرج", "نظرآباد", "فردیس", "اشتهارد", "هشتگرد", "طالقان"],
};

const CustomSelect = ({ label, value, onChange, options, error }) => {
  const theme = useTheme();
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Select
        labelId={`${label}-label`}
        value={value}
        onChange={onChange}
        sx={{
          border: `${error ? `1px solid ${theme.palette.error.main}` : "none"}`,
          borderRadius: "8px",
          fontFamily: "IRANSANSWEB",
          "&:hover": {
            border: "none",
          },
          "&.Mui-focused": {
            border: `1px solid ${theme.palette.button.main}`,
          },
          "&.MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiOutlinedInput-root": {
            border: "none",
          },
          color: theme.palette.white.main,
          backgroundColor: theme.palette.fieldFill.main,
          fontSize: `${value.length > 8 ? "0.8rem" : "1.2rem"}`,
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          "& .MuiSelect-select": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: theme.palette.fieldFill.main,
              color: theme.palette.white.main,
              maxHeight: "200px",
              maxWidth: "250px",
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            sx={{ fontFamily: "IRANSANSWEB", direction: "rtl" }}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

const ProvinceCitySelector = ({
  selectedProvince,
  setSelectedProvince,
  selectedCity,
  setSelectedCity,
  emptySelect,
}) => {
  const handleProvinceChange = (event) => {
    setSelectedProvince(event.target.value);
    setSelectedCity("");
  };

  const handleCityChange = (event) => {
    setSelectedCity(event.target.value);
  };

  return (
    <Box
      sx={{
        width: "90%",
        height: "70px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ width: "48%", height: "70px" }}>
        <CustomSelect
          label="استان"
          value={selectedProvince}
          onChange={handleProvinceChange}
          options={Object.keys(provinces)}
          error={emptySelect && !selectedProvince}
        />
      </Box>
      <Box sx={{ width: "48%", height: "70px" }}>
        {selectedProvince && (
          <CustomSelect
            label="شهر"
            value={selectedCity}
            onChange={handleCityChange}
            options={provinces[selectedProvince]}
            error={emptySelect && !selectedCity}
            placeholder="شهر"
          />
        )}
      </Box>
    </Box>
  );
};

export default ProvinceCitySelector;
